<section class="forms-container">
  <ng-container *ngIf="!showError;else elseError">
    <div class="ids-mv-6 ids-p-3">
      <div class="breadcrumb-box">
        <button idsActionButton (click)="logoff()">
          <ids-icon variant="primary" id="backButton">seta_esquerda</ids-icon>
          voltar
        </button>
      </div>
      <div class="ids-pt-8">
        <ids-shimmer [show]="isLoadingFormsList" height="2em">
          <h2 class="ids-text-title-01">Olá, {{ sellerNameOrCompany }}!</h2>
        </ids-shimmer>
        <p class="ids-pv-4">
          Você está mais perto de vender seu imóvel. Preencha os formulários para continuar:
        </p>
      </div>

      <div class="ids-pt-7">
        <div class="ids-banner-highlight">
          <div class="ids-d-flex">
            <img aria-hidden="true" alt="bell" [src]="environment.assetsRoot + '/notification_fb-warning.svg'"/>
          </div>
          <div class="ids-banner-highlight__container">
            <p class="ids-banner-highlight__title">
              <strong>Importante</strong>
            </p>
            As informações são salvas apenas ao concluir cada formulário. A sessão fica disponível por até 1 hora e, se
            encerrar, apenas os formulários concluídos permanecerão salvos
          </div>
        </div>
      </div>

      <div class="ids-pb-8 ids-pt-7">
        <ol idsList class="ids-pb-10" *ngIf="!isLoadingFormsList">
          <!-- forms dados pessoais | cenário: preenchido -->
          <li idsLi *ngIf="sellerFormPersonalData?.isFilled">
            <ids-icon idsLiIcon>{{ sellerIsPf ? 'user_base' : 'company_base' }}</ids-icon>
            <span idsLiText>{{ sellerIsPf ? 'dados pessoais' : 'dados da empresa' }}</span>
            <span idsLiSupporting class="ids-tag -success">preenchido</span>
          </li>
          <!-- forms dados pessoais | cenário: não preenchido -->
          <li *ngIf="!sellerFormPersonalData?.isFilled">
            <button idsLi (click)="goToForm(sellerFormPersonalData)">
              <ids-icon idsLiIcon>{{ sellerIsPf ? 'user_base' : 'company_base' }}</ids-icon>
              <span idsLiText>{{ sellerIsPf ? 'dados pessoais' : 'dados da empresa' }}</span>
              <span idsLiSupporting class="ids-tag -outline">pendente</span>
            </button>
          </li>
          <!-- form divisão do imóvel | cenário: botão desabilitado e dados pessoais não preenchido -->
          <li *ngIf="!sellerFormPersonalData?.isFilled">
            <button idsLi (click)="goToForm(sellerFormPropertyDivision)" disabled>
              <ids-icon idsLiIcon>percent_base</ids-icon>
              <span idsLiText>divisão do imóvel</span>
              <span
                idsLiSubText>{{ sellerIsPf ? 'disponível após dados pessoais' : 'disponível após dados da empresa' }}</span>
              <span idsLiSupporting class="ids-tag -outline ids-tag-disabled">pendente</span>
            </button>
          </li>
          <!-- form divisão do imóvel | cenário: botão habilitado e dados pessoais preenchido -->
          <li *ngIf="sellerFormPersonalData?.isFilled">
            <button idsLi (click)="goToForm(sellerFormPropertyDivision)">
              <ids-icon idsLiIcon>percent_base</ids-icon>
              <span idsLiText>divisão do imóvel</span>
              <span idsLiSupporting class="ids-tag"
                    [ngClass]="sellerFormPropertyDivision?.isFilled ? '-success' : '-outline' ">
                {{ sellerFormPropertyDivision?.isFilled ? 'preenchido' : 'pendente' }}</span>
            </button>
          </li>
        </ol>

        <!--  mostra para o usuario que está carregando algo -->
        <ids-shimmer [show]="isLoadingFormsList" height="4em"></ids-shimmer>

        <!-- mostra para o usuario que está carregando algo -->
        <ids-shimmer class="ids-mt-4 ids-mb-10" [show]="isLoadingFormsList" height="4em"></ids-shimmer>

        <div class="ids-row" *ngIf="isUserSeller()">
          <div class="ids-col-4">
            <button idsMainButton full [disabled]="!enableFormFilled" [loading]="loadingSubmit" (click)="submitForms()">
              enviar formulários
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #elseError>
    <app-error-screen (onClickTryAgain)="reciverTryAgain()" [errorCount]="errorCount"></app-error-screen>
  </ng-template>
</section>

